import { isValidPhoneNumber } from "libphonenumber-js"
import * as Yup from "yup"
import { validateSpanishID } from "./spanishIdValidator"

const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&/\\()?¿*\-+=^,;.:_{}[\]]).{8,}$/

export const FAX_REGEX = /^\+?[0-9]+$/

export const PDF_REGEX = /(pdf)$/

export const PASSWORDS_NOT_MATCH_MSG = (t: $TSMigrationFixMe) =>
  `${t("errors.passwordNotMatch")}`
export const PASSWORD_INVALID_MSG = (t: $TSMigrationFixMe) =>
  `${t("errors.minCriteriaPassword")}`

export const validateRazonSocial = (t: $TSMigrationFixMe) => {
  const msgCompanyNameEmpty = t("errors.companyNameEmpty")
  return Yup.string().nullable().required(msgCompanyNameEmpty)
}

export const validateCif = (t: $TSMigrationFixMe) => {
  const msgCifEmpty = t("errors.nifEmpty")
  const msgCifInvalid = t("errors.nifInvalid")
  return Yup.string()
    .required(msgCifEmpty)
    .nullable()
    .test("len", msgCifInvalid, (cif) => validateSpanishID(cif || ""))
}

export const validateEmail = (t: $TSMigrationFixMe) => {
  const msgMailInvalid = t("errors.mailInvalid")
  const msgMailEmpty = t("errors.mailEmpty")
  return Yup.string().email(msgMailEmpty).nullable().required(msgMailInvalid)
}

export const validateFax = (t: $TSMigrationFixMe) => {
  const msgFaxEmpty = t("errors.faxEmpty")
  const msgFaxInvalid = t("errors.faxInvalid")
  return (
    Yup.string()
      .required(msgFaxEmpty)
      .ensure()
      // @ts-expect-error TS(2322): Type 'RegExpMatchArray | null' is not assignable t...
      .test("", msgFaxInvalid, (fax) => fax.match(FAX_REGEX))
  )
}

export const validateWeb = (t: $TSMigrationFixMe) => {
  const msgWebEmpty = t("errors.webEmpty")
  return Yup.string().required(msgWebEmpty)
}

export const validateTelefonoNotRequired = (t: $TSMigrationFixMe) => {
  const msgTlfInvalid = t("errors.tlfInvalid")
  return (
    Yup.string()
      .nullable()
      // @ts-expect-error TS(2345): Argument of type '(this: TestContext<AnyObject>, t...
      .test("", msgTlfInvalid, (telefono) => {
        return (
          !telefono || (telefono && isValidPhoneNumber(telefono || "", "ES"))
        )
      })
  )
}
export const validateMovil = (t: $TSMigrationFixMe) => {
  const msgMobileEmpty = t("errors.mobileEmpty")
  const msgMobileInvalid = t("errors.mobileInvalid")
  return Yup.string()
    .nullable()
    .required(msgMobileEmpty)
    .test("", msgMobileInvalid, (telefono) => {
      return isValidPhoneNumber(telefono || "", "ES")
    })
}

export const validateTelefono = (t: $TSMigrationFixMe) => {
  const msgTlfEmpty = t("errors.tlfEmpty")
  const msgTlfInvalid = t("errors.tlfInvalid")
  return Yup.string()
    .nullable()
    .required(msgTlfEmpty)
    .test("", msgTlfInvalid, (telefono) => {
      return isValidPhoneNumber(telefono || "", "ES")
    })
}

export const validateDireccion = (t: $TSMigrationFixMe) => {
  const msgDireccionEmpty = t("errors.directionEmpty")
  return Yup.string().nullable().required(msgDireccionEmpty)
}

export const validateCodigoPostal = (t: $TSMigrationFixMe) => {
  const msgZipCodeMinCaracter = t("errors.zipCodeMinCaracter")
  const msgZipCodeEmpty = t("errors.zipCodeEmpty")
  return Yup.string()
    .length(5, msgZipCodeMinCaracter)
    .nullable()
    .required(msgZipCodeEmpty)
}

export const validateProvincia = (t: $TSMigrationFixMe) => {
  const msgProvinceEmpty = t("errors.provinceEmpty")
  return Yup.string().required(msgProvinceEmpty)
}

export const validatePoblacion = (t: $TSMigrationFixMe) => {
  const msgPoblationEmpty = t("errors.poblationEmpty")
  return Yup.string().required(msgPoblationEmpty).nullable()
}

export const validatePassword = (t: $TSMigrationFixMe) => {
  const msgPasswordEmpty = t("errors.passwordEmpty")
  return Yup.string()
    .required(msgPasswordEmpty)
    .matches(PASSWORD_REGEX, PASSWORD_INVALID_MSG(t))
}

export const validateRepeatPassword = (t: $TSMigrationFixMe) => {
  const msgPasswordEmpty = t("errors.passwordEmpty")
  return Yup.string()
    .required(msgPasswordEmpty)
    .oneOf([Yup.ref("password")], PASSWORDS_NOT_MATCH_MSG(t))
}

export const isValidEmail = (email = "") => EMAIL_REGEXP.test(email)

export const validateNif = (t: $TSMigrationFixMe) => {
  const msgNifEmpty = t("errors.nifEmpty")
  const msgNifInvalid = t("errors.nifInvalid")
  return Yup.string()
    .required(msgNifEmpty)
    .nullable()
    .test("len", msgNifInvalid, (cif) => validateSpanishID(cif || ""))
}

export const IBAN_REGEX = "ES[a-zA-Z0-9]{2}s?([0-9]{4}s?){5}s?"
export const IBAN_STRUCTURE_REGEX = "(^.{1,1}[A-Z]).{15,33}$"
export const validateIBAN = (value: $TSMigrationFixMe) => {
  const newRegex = new RegExp(IBAN_STRUCTURE_REGEX)
  return newRegex.test(value)
}
